import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Projectmember } from '@src/app/components/footer/model/projectmember';
import { SessionHelper } from '@src/app/helpers/sessionHelper';
import { environment } from '@src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CustomertasklistService {

  constructor(private http:HttpClient) { }

  getCustomerMembers(customerId:string){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
    var pit = new Date().toISOString();
    //try cast to Projectmember
    return this.http.get<Projectmember[]>(environment.apiUrl+'/organization/'+SessionHelper.getChoosenOrg()+'/customer/'+customerId.substring(0,36)+'/user/list/pit/'+pit,httpOptions)

  }
}
